import { svg_capacitor } from "src/app/shared/config/icon-svgs/capacitor";
import { svg_circuit_breaker } from "src/app/shared/config/icon-svgs/circuit_breaker";
import { svg_cmr_recloser } from "src/app/shared/config/icon-svgs/cmr_recloser";
import { svg_distributed_generator } from "src/app/shared/config/icon-svgs/distributed_generator";
import { svg_elbow } from "src/app/shared/config/icon-svgs/elbow";
import { svg_fuse } from "src/app/shared/config/icon-svgs/fuse";
import { svg_hyd_recloser } from "src/app/shared/config/icon-svgs/hyd_recloser";
import { svg_load } from "src/app/shared/config/icon-svgs/load";
import { svg_oh_distribution_transformer } from "src/app/shared/config/icon-svgs/oh_distribution_transformer";
import { svg_pole } from "src/app/shared/config/icon-svgs/pole";
import { svg_recloser } from "src/app/shared/config/icon-svgs/recloser";
import { svg_regulator } from "src/app/shared/config/icon-svgs/regulator";
import { svg_sectionalizer } from "src/app/shared/config/icon-svgs/sectionalizer";
import { svg_station_transformer } from "src/app/shared/config/icon-svgs/station_transformer";
import { svg_step_transformer } from "src/app/shared/config/icon-svgs/step_transformer";
import { svg_substation } from "src/app/shared/config/icon-svgs/substation";
import { svg_switch } from "src/app/shared/config/icon-svgs/switch";
import { svg_trip_saver_recloser } from "src/app/shared/config/icon-svgs/trip_saver_recloser";
import { svg_ug_distribution_transformer } from "src/app/shared/config/icon-svgs/ug_distribution_transformer";

/*
Retriees the SVG code as a string for a given asset type.
@param assetType The type of the asset as a string.
@returns The SVG code corresponding to the asset type.
@example
const assetSvg = assetTypeToSvgMapping[asset.asset_type];
*/
export const assetTypeToSvgMapping: { [key: string]: string } = {
  CAPACITOR: svg_capacitor,
  CIRCUIT_BREAKER: svg_circuit_breaker,
  DISTRIBUTED_GENERATOR: svg_distributed_generator,
  ELBOW: svg_elbow,
  FUSE: svg_fuse,
  LOAD: svg_load,
  POLE: svg_pole,
  OH_DISTRIBUTION_TRANSFORMER: svg_oh_distribution_transformer,
  ELECTRONIC_RECLOSER: svg_recloser,
  HYD_RECLOSER: svg_hyd_recloser,
  CMR_RECLOSER: svg_cmr_recloser,
  TRIP_SAVER_RECLOSER: svg_trip_saver_recloser,
  REGULATOR: svg_regulator,
  SECTIONALIZER: svg_sectionalizer,
  STATION_TRANSFORMER: svg_station_transformer,
  STEP_TRANSFORMER: svg_step_transformer,
  SUBSTATION: svg_substation,
  SWITCH: svg_switch,
  UG_DISTRIBUTION_TRANSFORMER: svg_ug_distribution_transformer,
};
